export class VkmVehicle {
    id: number;
    user_id: number;
    date: Date;
    vehicle: string;
}
